import AdminWhite from './adminwhite';
import Airplane from './airplane';
import AmericanExpress from './american-express';
import ApplicationAdmin from './application-admin';
import ApplicationBilling from './application-billing';
import ApplicationDevices from './application-devices';
import ApplicationHome from './application-home';
import ApplicationReports from './application-reports';
import ApplicationRoutes from './application-routes';
import ApplicationSettings from './application-settings';
import ApplicationUsage from './application-usage';
import BlackLogoBlackText from './blacklogo-blacktext';
import BillingWhite from './billingwhite';
import CellTower from './cell-tower';
import CheckmarkIconCustom from './checkmark-icon-custom';
import ChevronWhite from './chevronswhite';
import ConsoleIcon from './console';
import CsvIcon from './csv';
import EmptySearch from './empty-search';
import Error from './error';
import GreenRibbon from './green-ribbon';
import HomeWhite from './homewhite';
import HyperMajor from './hyper-major';
import HyperMinor from './hyper-minor';
import LogoWhite from './logo';
import LogoRainbow from './logorainbow';
import Mastercard from './mastercard';
import MessageInbound from './message-inbound';
import MessageOutbound from './message-outbound';
import MissingDocument from './missing-document';
import RainbowLogoBlackText from './rainbowlogo-blacktext';
import RainbowLogoWhiteText from './rainbowlogo-whitetext';
import RoutesWhite from './routeswhite';
import SearchError from './search-error';
import SettingsWhite from './settingswhite';
import SimsCircle from './sims-circle';
import Spinner from './spinner';
import TagManager from './tag-manager';
import UsageWhite from './usagewhite';
import Visa from './visa';

export const iconNames = {
  ADMIN_WHITE: 'admin-white',
  AMERICAN_EXPRESS: 'american-express',
  APPLICATION_ADMIN: 'application-admin',
  APPLICATION_BILLING: 'application-billing',
  APPLICATION_DEVICES: 'application-devices',
  APPLICATION_HOME: 'application-home',
  APPLICATION_REPORTS: 'application-reports',
  APPLICATION_ROUTES: 'application-routes',
  APPLICATION_SETTINGS: 'application-settings',
  APPLICATION_USAGE: 'application-usage',
  AIRPLANE: 'airplane',
  BLACK_LOGO_BLACK_TEXT: 'black-logo-black-text',
  BILLING_WHITE: 'billing-white',
  CELL_TOWER: 'cell-tower',
  CHECKMARK_ICON_CUSTOM: 'checkmark-icon-custom',
  CHEVRONS_WHITE: 'chevrons-white',
  CONSOLE: 'console',
  CSV_ICON: 'csv-icon',
  EMPTY_SEARCH: 'empty-search',
  ERROR: 'error',
  GREEN_RIBBON: 'green-ribbon',
  HOME_WHITE: 'home-white',
  HYPER_MAJOR: 'hyper-major',
  HYPER_MINOR: 'hyper-minor',
  LOGO_RAINBOW: 'logo-rainbow',
  LOGO_WHITE: 'logo',
  MASTERCARD: 'mastercard',
  MESSAGE_OUTBOUND: 'message-outbound',
  MESSAGE_INBOUND: 'message-inbound',
  MISSING_DOCUMENT: 'missing-document',
  RAINBOW_LOGO_BLACK_TEXT: 'rainbow-logo-black-text',
  RAINBOW_LOGO_WHITE_TEXT: 'rainbow-logo-white-text',
  ROUTES_WHITE: 'routes-white',
  SETTINGS_WHITE: 'settings-white',
  SEARCH_ERROR: 'search-error',
  SIMS_CIRCLE: 'sims-circle',
  SPINNER: 'spinner',
  TAG_MANAGER: 'tag-manager',
  USAGE_WHITE: 'usage-white',
  VISA: 'visa',
};

export const icons = {
  [iconNames.ADMIN_WHITE]: AdminWhite,
  [iconNames.AMERICAN_EXPRESS]: AmericanExpress,
  [iconNames.APPLICATION_ADMIN]: ApplicationAdmin,
  [iconNames.APPLICATION_BILLING]: ApplicationBilling,
  [iconNames.APPLICATION_DEVICES]: ApplicationDevices,
  [iconNames.APPLICATION_HOME]: ApplicationHome,
  [iconNames.APPLICATION_REPORTS]: ApplicationReports,
  [iconNames.APPLICATION_ROUTES]: ApplicationRoutes,
  [iconNames.APPLICATION_SETTINGS]: ApplicationSettings,
  [iconNames.APPLICATION_USAGE]: ApplicationUsage,
  [iconNames.AIRPLANE]: Airplane,
  [iconNames.BLACK_LOGO_BLACK_TEXT]: BlackLogoBlackText,
  [iconNames.BILLING_WHITE]: BillingWhite,
  [iconNames.CELL_TOWER]: CellTower,
  [iconNames.CHECKMARK_ICON_CUSTOM]: CheckmarkIconCustom,
  [iconNames.CHEVRONS_WHITE]: ChevronWhite,
  [iconNames.CONSOLE]: ConsoleIcon,
  [iconNames.CSV_ICON]: CsvIcon,
  [iconNames.EMPTY_SEARCH]: EmptySearch,
  [iconNames.ERROR]: Error,
  [iconNames.GREEN_RIBBON]: GreenRibbon,
  [iconNames.HOME_WHITE]: HomeWhite,
  [iconNames.HYPER_MAJOR]: HyperMajor,
  [iconNames.HYPER_MINOR]: HyperMinor,
  [iconNames.LOGO_RAINBOW]: LogoRainbow,
  [iconNames.LOGO_WHITE]: LogoWhite,
  [iconNames.MASTERCARD]: Mastercard,
  [iconNames.MESSAGE_OUTBOUND]: MessageOutbound,
  [iconNames.MESSAGE_INBOUND]: MessageInbound,
  [iconNames.MISSING_DOCUMENT]: MissingDocument,
  [iconNames.RAINBOW_LOGO_BLACK_TEXT]: RainbowLogoBlackText,
  [iconNames.RAINBOW_LOGO_WHITE_TEXT]: RainbowLogoWhiteText,
  [iconNames.ROUTES_WHITE]: RoutesWhite,
  [iconNames.SETTINGS_WHITE]: SettingsWhite,
  [iconNames.SEARCH_ERROR]: SearchError,
  [iconNames.SIMS_CIRCLE]: SimsCircle,
  [iconNames.SPINNER]: Spinner,
  [iconNames.TAG_MANAGER]: TagManager,
  [iconNames.USAGE_WHITE]: UsageWhite,
  [iconNames.VISA]: Visa,
};
